export default __webpack_public_path__ + "images/widget.97b6e27146bfd8058edf5138215d17a5.png";